
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore } from "@/store/store";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import StandardButton from "@/components/UI/StandardButton.vue";
import { saveGlobalSettingsToWordPress } from "@/lib/global-settings/global-settings";
import { saveSelectorsToWordPress } from "@/lib/selectors/selectors";

@Component({
  components: {
    StandardButton
  }
})
export default class BrowseModeSave extends Vue {
  saveInProgress = false;

  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }

  async save() {
    this.saveInProgress = true;

    await saveGlobalSettingsToWordPress();
    await saveSelectorsToWordPress();

    this.saveInProgress = false;
  }

  mounted() {
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_S, this.save);
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_S);
  }
}
